

























import {
  defineComponent,
  computed,
  ref,
  Ref,
  watchEffect,
} from '@nuxtjs/composition-api'

export function formatDate(date: string | null) {
  if (!date) return ''

  return date.split('-').reverse().join('.')
}

export default defineComponent({
  props: {
    isBirthdayPicker: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['input'],
  setup: (props, { emit }) => {
    const menu = ref(false)
    const date: Ref<string> = ref('')
    const activePicker = ref()

    const formatedDate = computed(() => formatDate(date.value))

    const maxDate = computed(() => {
      if (props.isBirthdayPicker) {
        // today
        return new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
          .toISOString()
          .substr(0, 10)
      }

      return undefined
    })

    const minDate = computed(() =>
      props.isBirthdayPicker ? '1950-01-01' : undefined
    )

    watchEffect(() => {
      if (menu.value && props.isBirthdayPicker) {
        setTimeout(() => (activePicker.value = 'YEAR'))
      }
    })

    watchEffect(function () {
      return emit('input', date.value)
    })

    function clear() {
      menu.value = true
      date.value = ''
    }

    return {
      menu,
      date,
      formatedDate,
      maxDate,
      minDate,
      activePicker,
      clear,
    }
  },
})
